import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../Enums/Size.enum';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import MagicFormPreview, {
	PlainTextTemplateItem,
} from './MagicFormPlainTextViewer';

interface Props extends BaseModalProps {
	formScheme: ItemScheme[];
	template: PlainTextTemplateItem[];
	onSubmit: (values: any) => void;
}

const MagicFormPlainTextViewerModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.textFormat' size={Size.XL}>
			<MagicFormPreview
				template={props.template}
				formScheme={props.formScheme}
				onSubmit={props.onSubmit}
			/>
		</BaseModal>
	);
};

export default MagicFormPlainTextViewerModal;
